export default __webpack_public_path__ + "static/media/freightclass.8effc21c.svg";